import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import PageRootWrapper from '../../components/common/PageRoot/PageRootWrapper';
import LeadsStatsContainer from '../../components/LeadsStats/LeadsStatsContainer';

const LeadsStats = ({ location }) => (
    <PageRootWrapper location={location}>
        <LeadsStatsContainer />
    </PageRootWrapper>
);

LeadsStats.propTypes = {
    location: ReactRouterPropTypes.location.isRequired,
};

export default LeadsStats;
